import { connect } from 'react-redux';
import { HomePageComponent } from './Home.page.component';
import { getKnowledgeContent } from 'shared/store/actions/knowledge.actions';
import { getCategoriesById, getRoot } from 'shared/store/selectors/knowledge.selector';

const mapStateToProps = ({ lang, knowledge }) => {
  let root = getRoot(knowledge);

  return {
    lang: lang.HOME_SCREEN,
    list: getCategoriesById(knowledge, root.id),
    id: root.id,
    fullPath: null,
    lastUpdated: knowledge.lastUpdated,
    isReady: knowledge.isReady,
  };
};

export const HomePage = connect(mapStateToProps, { getKnowledgeContent })(HomePageComponent);
